import React, { useState } from 'react';
import { VISIBLE_STAFFS } from './constants/magic_numbers';
import { nl2br } from '@/shared/nl2br';

const ConceptTagItem = ({ tag }) => {
    const [isOpen, setIsOpen] = useState(false);

    const togglePost = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={`concept-message-qa background-color--contents_bg border-color--border ${isOpen ? 'is-open' : ''}`}>
            <div className="concept-message-qa__summary color--accent" onClick={togglePost}>
                <p className="concept-message-qa__title color--text font-family--middle">
                <span className="concept-message-qa__head font-family--middle color--accent">Q</span>
                {tag.concept_tag.name}
                </p>
            </div>
            <div className="concept-message-qa__item">
                {isOpen && (
                <>
                    <p className="concept-message-qa__subtitle color--accent font-family--middle">{tag.title}</p>
                    <p className="concept-message-qa__text color--text special__text">{nl2br(tag.answer)}</p>
                </>
                )}
            </div>
        </div>
    );
};

const Staff = ({ staffs }) => {
    const [visibleCount, setVisibleCount] = useState(VISIBLE_STAFFS);

    const showMoreStaffs = () => {
        setVisibleCount((prevCount) => prevCount + VISIBLE_STAFFS);
    };

    return (
        <>
            <div className="concept-message">
                <div className="heading--2">
                    <h2 className="heading__text color--accent font-family--large">大切にしている想い</h2>
                </div>
                <ul className="concept-message__list">
                    {staffs.slice(0, visibleCount).map((staff) => (
                        <li className="concept-message__item" key={staff.id}>
                            <figure className="concept-message__img">
                                {staff.image.main_image_url ? (
                                    <>
                                        <img
                                            src={staff.image.main_image_url}
                                            alt={staff.name}
                                            width="1732"
                                            height="1154"
                                            loading="lazy"
                                        />
                                        <div
                                            className="concept-message__img--bg"
                                            style={{ backgroundImage: `url(${staff.image.main_image_url})` }}
                                        ></div>
                                    </>
                                ) : (
                                    <div className="concept-message__img--none background-color--accent"></div>
                                )}
                            </figure>

                            <div className="concept-message__inner background-color--contents_bg">
                                <div className="concept-message__detail">
                                    <img
                                        className="concept-message__icon"
                                        src={staff.image.icon_image_url}
                                        alt={`${staff.name}のスタッフアイコン`}
                                        width="145"
                                        height="145"
                                    />
                                    <div className="concept-message__staff">
                                        <div className="concept-message__info">
                                            <p className="concept-message__name font-family--middle color--text">
                                                {staff.name}
                                            </p>
                                            <p className="concept-message__profession font-family--middle color--text">
                                                {staff.role}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <p className="concept-message__text special__text color--text">{nl2br(staff.concept_text)}</p>
                                {staff.concept_tag_staff.map((tag, tagIndex) => (
                                    <ConceptTagItem key={tagIndex} tag={tag} />
                                ))}
                            </div>
                        </li>
                    ))}
                </ul>

                {visibleCount < staffs.length && (
                    <button
                        className="concept-btn-more border-color--border background-color--page_bg color--sub border-radius--btn font-family--middle"
                        onClick={showMoreStaffs}
                    >
                        もっと見る
                    </button>
                )}
            </div>
        </>
    );
};

export default Staff;
